import { Injectable } from '@angular/core';
import {
  CurrentWallboxConfigService,
  RemoteWallboxConfig,
} from '../../../../apps/keba-wallbox-app/src/app/services/current-wallbox-config.service';
import { LocalSettingsService } from './impl/local-settings.service';
import { RemoteSettingsService } from './impl/remote-settings.service';
import { ISettingsService, SettingAccessor } from './ISettingsService';
import { ObjectKeys } from '../../../../apps/keba-wallbox-app/src/plugins/keba-wallbox-plugin';
import { WallboxAppConfiguration } from '../../../../apps/keba-wallbox-app/src/app/services/local-wallbox/settings/local-wallbox-settings.service';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  public constructor(
    private readonly currentWallboxConfigService: CurrentWallboxConfigService,
    private readonly localSettingsSerice: LocalSettingsService,
    private readonly remoteSettingsService: RemoteSettingsService
  ) {}

  private get service(): ISettingsService {
    const wallboxConfig = this.currentWallboxConfigService.getCurrentWallboxConfig();
    return wallboxConfig?.isLocalWallbox() === true ? this.localSettingsSerice : this.remoteSettingsService;
  }

  public readSetting(
    settingAccessor: SettingAccessor,
    wallboxId?: string
  ): Promise<string | string[] | undefined | ObjectKeys> {
    let remoteId = wallboxId ?? this.readRemoteId();
    return this.service.readSetting(settingAccessor, remoteId);
  }

  public getWallboxConfig(): WallboxAppConfiguration | undefined {
    return this.service.getWallboxConfig();
  }

  private readRemoteId(): string | undefined {
    const wallboxConfig = this.currentWallboxConfigService.getCurrentWallboxConfig();
    if (wallboxConfig?.isRemoteWallbox()) {
      return (wallboxConfig as RemoteWallboxConfig).id;
    }

    return undefined;
  }
}
